module.exports = require("@swa-ui/loyalty/src/form/PersonalInfoFormFields/PersonalInfoFormFields.module.scss");